export default {
  methods: {
    getCurrentTime () {
      let time = Date.now()
      return Math.round(time / 1000)
    }
  }
}
